import {
  InMemoryHeader,
  InMemoryString,
  InMemoryInteger
} from "pbas-vue-components";
import { translate2 } from '../trans2'


const InMemoryEmployersStoresHeaders = [
  // new InMemoryHeader({
  //   type: new InMemoryString("Stores[]/Translations[]/LanguageCode"),
  //   sortable: false,
  //   visible: false,
  //   allowVisibilityChange: false
  // }),
  // new InMemoryHeader({
  //   type: new InMemoryString("Stores[]/Name"),
  //   visible: false,
  //   allowVisibilityChange: false,
  // }),
  new InMemoryHeader({
    title: "globals.stores",
    type: new InMemoryString("Stores[]/Translations[]/Name", {
      getString: (item) => item.Stores?item.Stores.map(o=>translate2(o, "Name")).join(", "):"",
      getHtml: (item, type) => {
        return ("<div style='word-wrap: break-word; white-space: pre-wrap; min-width: 200px'>" +
          type.getString(item, type) +
          "</div>");
      }
    }),
    sortable: true,
    visible: true,
    allowVisibilityChange: true,
    searchable: true,
    orderByKey: "Name"
  }),
  // new InMemoryHeader({
  //   type: new InMemoryString("Stores[]/Id"),
  //   visible: false,
  //   allowVisibilityChange: false
  // }),
  // new InMemoryHeader({
  //   type: new InMemoryString("Stores[]/PlanIdentityId"),
  //   visible: false,
  //   allowVisibilityChange: false
  // }),
  // new InMemoryHeader({
  //   type: new InMemoryString("Stores[]/UniqueIdentifier"),
  //   visible: false,
  //   allowVisibilityChange: false
  // }),
  // new InMemoryHeader({
  //   type: new InMemoryInteger("Stores[]/Number"),
  //   visible: false,
  //   allowVisibilityChange: false
  // }),
  // new InMemoryHeader({
  //   type: new InMemoryString("Stores[]/EmployerId"),
  //   visible: false,
  //   allowVisibilityChange: false
  // }),
  // new InMemoryHeader({
  //   type: new InMemoryString("Stores[]/Address/City"),
  //   visible: false,
  //   allowVisibilityChange: false
  // }),
  // new InMemoryHeader({
  //   type: new InMemoryInteger("Stores[]/Address/StreetNumber"),
  //   visible: false,
  //   allowVisibilityChange: false
  // }),
  // new InMemoryHeader({
  //   type: new InMemoryString("Stores[]/Address/StreetName"),
  //   visible: false,
  //   allowVisibilityChange: false
  // }),
  // new InMemoryHeader({
  //   type: new InMemoryInteger("Stores[]/Address/SuiteNumber"),
  //   visible: false,
  //   allowVisibilityChange: false
  // }),
  // new InMemoryHeader({
  //   type: new InMemoryString("Stores[]/Address/Province/Name"),
  //   visible: false,
  //   allowVisibilityChange: false
  // }),
  // new InMemoryHeader({
  //   type: new InMemoryString("Stores[]/Address/Province/Id"),
  //   visible: false,
  //   allowVisibilityChange: false
  // }),
  // new InMemoryHeader({
  //   type: new InMemoryString("Stores[]/Address/ProvinceId"),
  //   visible: false,
  //   allowVisibilityChange: false
  // }),
  // new InMemoryHeader({
  //   type: new InMemoryString("Stores[]/Address/Province/Code"),
  //   visible: false,
  //   allowVisibilityChange: false
  // }),
  // new InMemoryHeader({
  //   type: new InMemoryString("Stores[]/Address/PostalCode"),
  //   visible: false,
  //   allowVisibilityChange: false
  // }),
  // new InMemoryHeader({
  //   type: new InMemoryString("Stores[]/PhoneNumber"),
  //   visible: false,
  //   allowVisibilityChange: false
  // }),
  // new InMemoryHeader({
  //   type: new InMemoryString("Stores[]/Fax"),
  //   visible: false,
  //   allowVisibilityChange: false
  // }),
  // new InMemoryHeader({
  //   type: new InMemoryString("Stores[]/Email"),
  //   visible: false,
  //   allowVisibilityChange: false
  // }),
  // new InMemoryHeader({
  //   type: new InMemoryString("Stores[]/Status/Name"),
  //   visible: false,
  //   allowVisibilityChange: false
  // }),
  // new InMemoryHeader({
  //   type: new InMemoryString("Stores[]/Status/Id"),
  //   visible: false,
  //   allowVisibilityChange: false
  // }),
  // new InMemoryHeader({
  //   type: new InMemoryString("Stores[]/StatusId"),
  //   visible: false,
  //   allowVisibilityChange: false
  // })
];
export default InMemoryEmployersStoresHeaders;